import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const theme = createTheme({
    palette: {
      primary: {
        main: "#D4D9B4",
        light: "#F2E7DC",
        dark: "#0D0D0D",
      },
      secondary: {
        main: "#F2F2F2",
        light: "#A9D9D0",
        dark: "#027373",
      },
      error: {
        main: red.A400
      }
    }
  });

export default theme;